import { createAction, props } from '@ngrx/store';
import { UserDialogView } from 'src/app/landing-page/landing-page.modal';
import {
  ContactUsDetails,
  ContactUsResponse,
  FPDetails,
  LandingHttpResponse,
  SignInDetails,
  SignInResponse,
  SignUpDetails,
  SignUpResponse,
} from '../state/landing-page.state';

export const setActiveSignButton = createAction(
  '[LANDING_PAGE] SET_ACTIVE_SIGN_Button',
  props<{ activeSignButton: UserDialogView }>(),
);

export const signIn = createAction(
  '[LANDING_PAGE] SIGN_IN_SUBMIT',
  props<{ signInDetails: SignInDetails }>(),
);

export const signInSuccess = createAction(
  '[LANDING_PAGE] SIGN_IN_SUCCESS',
  props<{ signInResponse: SignInResponse }>(),
);

export const signInError = createAction('[LANDING_PAGE] SIGN_IN_ERROR');

export const signUp = createAction(
  '[LANDING_PAGE] SIGN_UP',
  props<{ signUpDetails: SignUpDetails }>(),
);

export const signUpSuccess = createAction(
  '[LANDING_PAGE] SIGN_UP_SUCCESS',
  props<{ signUpResponse: SignUpResponse }>(),
);

export const signUpError = createAction('[LANDING_PAGE] SIGN_UP_ERROR');

export const resetPassword = createAction(
  '[LANDING_PAGE] RESET_PASSWORD',
  props<{ fpDetails: FPDetails }>(),
);

export const resetPasswordSuccess = createAction(
  '[LANDING_PAGE] RESET_PASSWORD_SUCCESS',
);

export const resetPasswordError = createAction(
  '[LANDING_PAGE] RESET_PASSWORD_ERROR',
);

export const requestOTP = createAction(
  '[LANDING_PAGE] REQUEST_OTP',
  props<{ emailId: string }>(),
);

export const requestOTPSuccess = createAction(
  '[LANDING_PAGE] REQUEST_OTP_SUCCESS',
);

export const requestOTPError = createAction('[LANDING_PAGE] REQUEST_OTP_ERROR');

export const setReactivateKey = createAction(
  '[LANDING_PAGE] SET_REACTIVATE_KEY',
  props<{ reactivateKey: string | null }>(),
);

export const reactivateAccount = createAction(
  '[LANDING_PAGE] REACTIVATE_ACCOUNT',
  props<{ reactivateKey: string }>(),
);

export const reactivateAccountSuccess = createAction(
  '[LANDING_PAGE] REACTIVATE_ACCOUNT_SUCCESS',
  props<{ response: LandingHttpResponse }>(),
);

export const reactivateAccountError = createAction(
  '[LANDING_PAGE] REACTIVATE_ACCOUNT_ERROR',
  props<{ errorMessage: string }>(),
);

export const resetReactivateAccountState = createAction(
  '[LANDING_PAGE] RESET_REACTIVATE_ACCOUNT_STATE',
);

export const submitContactUs = createAction(
  '[LANDING_PAGE] SUBMIT_CONTACT_US',
  props<{ contactUsDetails: ContactUsDetails }>(),
);

export const submitContactUsSuccess = createAction(
  '[LANDING_PAGE] SUBMIT_CONTACT_US_SUCCESS',
  props<{ contactUsResponse: ContactUsResponse }>(),
);

export const submitContactUsError = createAction(
  '[LANDING_PAGE] SUBMIT_CONTACT_US_ERROR',
);

export const resetContactUsRequestStatus = createAction(
  '[LANDING_PAGE] RESET_CONTACT_US_REQUEST_STATUS',
);

export const resetSignInRequestStatus = createAction(
  '[LANDING_PAGE] RESET_SIGN_IN_REQUEST_STATUS',
);

export const resetSignUpRequestStatus = createAction(
  '[LANDING_PAGE] RESET_SIGN_UP_REQUEST_STATUS',
);

export const resetRequestOTPRequestStatus = createAction(
  '[LANDING_PAGE] RESET_REQUEST_OTP_REQUEST_STATUS',
);

export const resetChangePasswordRequestStatus = createAction(
  '[LANDING_PAGE] RESET_CHANGE_PASSWORD_REQUEST_STATUS',
);
